import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid, ResponsiveContainer } from 'recharts';



const BarGraph = ({ data = [], labelColor = [] }) => {

    const legendFormatter = (value) => {
        return <span style={{ color: '#394256', 'font-size': '12px', 'font-family': 'Poppins, sans-serif', 'font-weight': '500', }}>{value}</span>;
    };

    const tooltipFormatter = (value, name, props) => {
        const { color } = props;
        return <span style={{ color, fontFamily: 'Poppins' }}>{`${value}`}</span>;
    };


    // const data = [
    //     { name: 'Andhra Pradesh', conversion: 100, cpa: 50 },
    //     { name: 'Assam', conversion: 150, cpa: 80 },
    //     { name: 'Bihar', conversion: 80, cpa: 40 },
    //     { name: 'Chandigarh', conversion: 120, cpa: 60 },
    //     { name: 'Delhi', conversion: 110, cpa: 90 },
    //     { name: 'Goa', conversion: 100, cpa: 90 },
    //     { name: 'Gujarat', conversion: 60, cpa: 40 },
    //     { name: 'Haryana', conversion: 66, cpa: 33 },
    //     { name: 'Kerala', conversion: 18, cpa: 12 },
    //     { name: 'Uttar Pradesh', conversion: 67, cpa: 57 },
    //     { name: 'Uttarakhand', conversion: 80, cpa: 20 },
    //     { name: 'Tripura', conversion: 50, cpa: 10 },
    //     { name: 'Punjab', conversion: 54, cpa: 23 },



    //     // Add more data as needed
    // ];
    const dataKeys = Object.keys(data && data.length && data[0]).slice(1);
    const legendItems = dataKeys.map((key, index) => {
        return { value: key.charAt(0).toUpperCase() + key.slice(1).toLowerCase(), type: 'circle', id: key, color: labelColor[index] }
    })

    // [
    //     { value: 'Conversion', type: 'circle', id: 'conversion', color: '#3768BF' },
    //     { value: 'CPA', type: 'circle', id: 'cpa', color: '#0B91B4' },
    //     // Add more legend items as needed
    // ];
    // console.log(data);
    // console.log(legendItems);
    // console.log(dataKeys);


    // const CustomXAxisTickComponent = ({ x, y, payload }) => {
    //     // Customize the appearance of the tick label
    //     return (
    //       <g transform={`translate(${x},${y})`}>
    //         <text
    //           x={0}
    //           y={0}
    //           dy={16}
    //           textAnchor="end"
    //           fill="#666" // Adjust the color as needed
    //           transform="rotate(-45)" // Rotate the label if necessary
    //         >
    //           {payload.value}
    //         </text>
    //       </g>
    //     );
    //   };

    const CustomXAxisTickComponent = ({ x, y, payload }) => {
        const maxLabelLength = 12; // Adjust as needed

        // Truncate label if it's too long
        const truncatedLabel = payload.value.length > maxLabelLength
            ? `${payload.value.substring(0, maxLabelLength)}...`
            : payload.value;

        return (
            <g transform={`translate(${x},${y})`}>
                <text
                    x={0}
                    y={0}
                    dy={24} // Adjusted vertical offset to prevent overlap
                    textAnchor="end" // Keeps text aligned to the end
                    fill="#666" // Text color
                    transform="rotate(-35)" // Reduced angle to prevent overlap
                    style={{ fontFamily: 'Poppins, sans-serif', fontSize: '11px' }}
                >
                    {truncatedLabel}
                </text>
            </g>
        );
    };

    return (
        <ResponsiveContainer width="100%" height={227}>
            {dataKeys && dataKeys.length > 0 ? <BarChart data={data} margin={{ top: 10, right: 25, left: 10, bottom: 60 }}>
                <Legend payload={legendItems} formatter={legendFormatter} verticalAlign="bottom" wrapperStyle={{ marginBottom: '-60px' }} />
                {/* <Legend payload={legendItems} formatter={legendFormatter} verticalAlign="bottom" wrapperStyle={{ marginBottom: '-75px' }} /> */}
                <CartesianGrid vertical={false} strokeDasharray={[]} />
                <XAxis
                    angle={-45}
                    interval={0}
                    dataKey="name"
                    axisLine={{ stroke: '#DCE3EE' }}
                    tickLine={null}
                    tick={<CustomXAxisTickComponent />}
                />
                <YAxis tick={{ fontFamily: 'Poppins' }} tickLine={null} axisLine={false} />
                <Tooltip contentStyle={{ fontFamily: 'Poppins' }} formatter={tooltipFormatter} />
                {
                    dataKeys.map((key, index) => (
                        <Bar dataKey={key} fill={labelColor[index]} barSize={16} radius={[4, 4, 0, 0]} gap={5} />
                    ))
                }
            </BarChart>
                :
                <h1 style={{
                    display: 'flex',
                    'flex-direction': 'row',
                    'flex-wrap': 'nowrap',
                    'align-content': 'center',
                    'justify-content': 'center',
                    'align-items': 'center',
                    'margin': '135px'
                }}>
                    No Data Available
                </h1>
            }
        </ResponsiveContainer>
    );
};

export default BarGraph;
